import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { toast } from 'sonner';

const AuthCallback = () => {
    const navigate = useNavigate();
    const { processOAuthCallback } = useAuth();
    const hasProcessed = useRef(false);

    useEffect(() => {
        // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
        // Use ref to prevent double processing in StrictMode
        if (hasProcessed.current) return;
        hasProcessed.current = true;

        const processCallback = async () => {
            const hash = window.location.hash;
            const search = window.location.search;
            
            // Check both hash and search params for session_id
            let sessionId = null;
            
            const hashMatch = hash.match(/session_id=([^&]+)/);
            if (hashMatch) {
                sessionId = hashMatch[1];
            }
            
            // Also check URL search params (some OAuth flows use query params)
            if (!sessionId) {
                const urlParams = new URLSearchParams(search);
                sessionId = urlParams.get('session_id');
            }
            
            // Also check for error parameter
            const urlParams = new URLSearchParams(search);
            const error = urlParams.get('error');
            if (error) {
                console.error('OAuth error:', error);
                toast.error(`Грешка при вход: ${error}`);
                navigate('/login', { replace: true });
                return;
            }
            
            if (sessionId) {
                try {
                    await processOAuthCallback(sessionId);
                    toast.success('Успешен вход с Google!');
                    // Clear the hash and navigate
                    window.history.replaceState(null, '', window.location.pathname);
                    navigate('/', { replace: true });
                } catch (error) {
                    console.error('OAuth callback error:', error);
                    toast.error('Грешка при вход с Google. Моля, опитайте отново.');
                    navigate('/login', { replace: true });
                }
            } else {
                console.log('No session_id found in URL. Hash:', hash, 'Search:', search);
                toast.error('Не беше получен session_id. Моля, опитайте отново.');
                navigate('/login', { replace: true });
            }
        };

        processCallback();
    }, [navigate, processOAuthCallback]);

    return (
        <div className="min-h-screen bg-background flex items-center justify-center">
            <div className="text-center">
                <div className="w-16 h-16 border-4 border-primary border-t-transparent rounded-full animate-spin mx-auto mb-4" />
                <p className="text-muted-foreground">Влизане...</p>
            </div>
        </div>
    );
};

export default AuthCallback;
